// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"24463286","703":"a53b52e8","787":"b00590ab"}[chunkId] + ".chunk.js";
};